module.exports = Object.freeze({
  NETWORK_UNDEFINED: 'Network is not found.',
  NETWORK_IS_NOT_SUPPORTED: 'Network is not supported yet.',
  SIGNER_UNDEFINED: 'Signer is not found.',
  SIGNER_PRIVATEKEY_UNDEFINED: 'Signer or private key must be set.',
  SIGNER_WIF_UNDEFINED: 'Signer or wif must be set.',
  METADATA_UNDEFINED: 'Metadata can not be blank.',
  CONTRACT_NAME_UNDEFINED: 'Contract name is required.',
  CONTRACT_ADDRESS_UNDEFINED: 'Contract address is required.',
  CONTRACT_ADDRESS_INVALID: 'Contract address is invalid.',
  CONTRACT_TYPE_UNDEFINED: 'Contract type is required.',
  CONTRACT_TYPE_IS_INVALID: 'Contract type is invalid.',
  CONTRACT_TYPE_IS_NOT_SUPPORTED: 'Contract type is not supported yet.',
  CONTRACT_TEMPLATE_UNDEFINED: 'Contract template is required.',
  CONTRACT_TEMPLATE_IS_INVALID: 'Contract template is invalid.',
  CONTRACT_METADATA_UNDEFINED: 'Contract metadata can not be blank.',
  CONTRACT_PATH_UNDEFINED: 'Contract path is required.',
  CONTRACT_AUTHOR_UNDEFINED: 'Contract author is required.',
  TOKEN_TYPE_UNDEFINED: 'Token type is required.',
  TOKEN_WRAPPABLE_UNDEFINED: 'Token wrappable is required.',
  TOKEN_WRAPPABLE_IS_MISSING_PARAMETER: 'Token wrappable is missing parameter.',
  TOKEN_TEMPLATE_UNDEFINED: 'Token template is required.',
  TOKEN_TEMPLATE_IS_INVALID: 'Token template is invalid.',
  TOKEN_PATH_UNDEFINED: 'Token path is required.',
  TOKEN_TYPE_IS_NOT_SUPPORTED: 'Token type is not supported yet.',
  RECIPIENT_ADDRESS_UNDEFINED: 'Recipient address is required.',
  CONTENTS_TO_WRAP_UNDEFINED: 'Contents can not be blank.',
  NFT_ID_QUANTITY_UNDEFINED: 'ID or quantity must be set.',
  BOTH_TOKEN_ID_AND_QUANTITY_ARE_REQUIRED: 'Both token id and quantity are required.',
  TOKEN_ID_UNDEFINED: 'Token id is required.',
  TOKEN_QUANTITY_UNDEFINED: 'Token quantity is required.',
  TOKEN_VERSION_UNDEFINED: 'Token version is required.',
  TOKEN_DECIMALS_UNDEFINED: 'Token decimals is required.',
  PRIMARY_SALE_RECIPIENT_UNDEFINED: 'Primary sale recipient is required.',
  TOKEN_NAME_UNDEFINED: 'Token name is required.',
  MINTS_UNDEFINED: 'Mints can not be blank.',
  HOST_UNDEFINED: 'Host is required.',
  CLAIM_CONDITIONS_UNDEFINED: 'Claim conditions can not be blank.',
  ROLES_UNDEFINED: 'Roles is required.',
  ROLE_CONTRACT_ADDRESS_INVALID: 'Contract address in role is invalid.',
  TRAMSACTIONUNDERPRICED: 'The gas fee was not accepted. Adjust the gas fee or try again later.',
  EXCEEDEDMAXQUANTITY: 'No more mints available as the issue limit has been reached.',
  WORDMISMATCH: 'The secret word is different.',
  USERDENIEDTRANSACTION: 'Transaction cancelled',
  EXECUTIONONLYALLOWEDBYOWNER: 'You are not authorized to perform this operation',
  INSUFFICIENTFUNDSFORGAS: 'Insufficient Gas price. Please replenish the balance',
  WLINVALIDADDRESS: 'Contains invalid address',
  NEED_HELP: 'Please contact admin for help'
});